import graphql__7ebab5d81d02b169794d from "./__generated__/EventMap_event.graphql.js";import { graphql, useFragment } from "react-relay";

import MapBase from "../Maps/MapBase";
import InformativeMarker from "../Maps/InformativeMarker";
import { useResponsiveFlag } from "../Utils/ResponsiveQueries";
import MapContextProvider from "../Maps/MapContext";

const EventMap = props => {
  const event = useFragment(EventMap_event, props.event);
  const { isDesktop } = useResponsiveFlag();
  const mapHeight = isDesktop ? 400 : 200;
  const { latitude, longitude, marker, map } = event;

  if (!latitude || !longitude) return null;

  return (
    <MapContextProvider>
      <div className="box box-image margin-bottom-xs">
        <MapBase
          map={map}
          height={mapHeight}
          centerLatitude={latitude}
          centerLongitude={longitude}
          className="box-shadow-lg"
        >
          <InformativeMarker
            marker={marker}
            tooltipProps={{ permanent: true, interactive: true }}
          />
        </MapBase>
      </div>
    </MapContextProvider>
  );
};

const EventMap_event = graphql__7ebab5d81d02b169794d;

export default EventMap;
